<script setup>
import { inject, defineProps, computed, onMounted, nextTick  } from 'vue';

const props = defineProps({
  index: Number
});

const accordion = inject('accordion');

const isOpen = computed(() => accordion.openTabs.value[props.index] || false);

function toggle() {
  if (isOpen.value) {
    // Close the current accordion if it's open
    accordion.openTabs.value[props.index] = false;
  } else {
    if (accordion.closeOthers.value) {
      // Close all others before opening the clicked one
      accordion.openTabs.value = {};
    }
    accordion.openTabs.value[props.index] = true;
  }
}

// Open the first accordion by default
onMounted(() => {
  if (props.index === 0) {
    accordion.openTabs.value[props.index] = true;
  }
});

</script>

<template>
  <div class="accordion-heading-full product-attributes" :class="{ open: isOpen }">
    <div class="panel panel-default">
      <div class="panel-heading" >
        <h4 class="panel-title">
          <a class="accordion-toggle" @click="toggle">
            <slot name="heading"></slot>
          </a>
        </h4>
      </div>
      <div class="panel-collapse" :class="!isOpen ? 'collapse' : 'in'" style="height: auto">
        <div class="panel-body">
          <Transition
            name="collapse"
          >
            <div class="row dl-leaders" v-show="isOpen">
              <slot></slot>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .collapse {
    display: none !important;
  }
  .collapse.in {
    display: block !important;
  }
</style>
